import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContactSupportService {
  isCaptureScreen: boolean = false;
  isAreaSelected: boolean = false;
  addScreenShot: Subject<any> = new Subject<any>();

  // The AddContactSupportMessage gRPC call now lives in the (lazy) ContactSupportComponent
  // — the only caller — so this eager-injected service no longer imports Business_pb /
  // Business_pb_service, keeping both out of the eager main.js bundle. This service is now
  // pure UI state (screenshot-capture flow) shared via DI.
}
